import { Color } from 'themes'
import { TKeyMetric } from 'types/GlobalKeyMetric'
import { TCustomizedMetric } from 'types/GlobalMetric'

export enum MemberType {
  OWNER = 'OWNER',
  MEMBER = 'MEMBER'
}

export enum MemberStatus {
  APPROVED = 'APPROVED',
  PENDING = 'PENDING'
}

export interface GroupMember {
  id: string
  account_id: string
  approved_at: Date | null
  invited_at: Date
  status: MemberStatus
  type: MemberType
}

export interface PatchGroupMemberBody {
  status?: MemberStatus.APPROVED
  type?: MemberType
}

export interface CreateGroupBody {
  profile_color: Color
  show_on_home: boolean
  is_private: boolean
  name: string
  owners: string[]
}

export type TGroupBase = {
  id: string
  name: string
  show_on_home: boolean
  is_private: boolean
  profile_color: Color
  members: GroupMember[] // members + owners
  metrics: {
    id: string
    index: number
    metric: TCustomizedMetric
  }[]
  dashboards: string[]
  pins: {
    id: string
    key_metric_id: string
    comment: string | null
  }[]
}

export type TGroupApi = TGroupBase & {
  key_metrics: string[]
}

export type TGroup = TGroupBase & {
  key_metrics: TKeyMetric[]
}

// TODO: remove "Select..."" types
export interface SelectGroupMember extends GroupMember {
  name: string
}

export interface SelectOneGroup extends TGroup {
  active_members: SelectGroupMember[]
  members: SelectGroupMember[]
  owners: SelectGroupMember[]
  pending: SelectGroupMember[]
}
